import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-phone-faq",
  "use": "icon-phone-faq-usage",
  "viewBox": "0 0 14 13.997",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 13.997\" id=\"icon-phone-faq\">\n  <path id=\"icon-phone-faq_np_phone_56382_000000\" d=\"M18.858,16.771a3.669,3.669,0,0,1-3.26,2.235c-.179,0-2.957.147-6.952-3.642A11.078,11.078,0,0,1,5,8.413c-.033-.607.14-2.129,2.234-3.26.259-.14.774-.2.907-.069.059.059,1.817,2.951,1.863,3.047a.647.647,0,0,1,.069.283.822.822,0,0,1-.283.5,4.862,4.862,0,0,1-.614.545,6.035,6.035,0,0,0-.614.525.754.754,0,0,0-.283.456c.013.309.266,1.413,2.191,3.106a14.848,14.848,0,0,0,2.943,2.2.674.674,0,0,0,.223.049.755.755,0,0,0,.456-.282c.185-.188.806-1.04,1.005-1.229A.82.82,0,0,1,15.6,14a.644.644,0,0,1,.282.069c.1.046,2.992,1.741,3.047,1.8.15.153.044.634-.069.906\" transform=\"translate(-5.001 -5.01)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/phone-faq.svg
// module id = 157
// module chunks = 0 1 2